// extracted by mini-css-extract-plugin
export var bg_grey_20 = "styles-module--bg_grey_20--YpwcO";
export var bg_grey_black = "styles-module--bg_grey_black--s6TIz";
export var blink = "styles-module--blink--EUNKd";
export var content = "styles-module--content--BcOv3";
export var home_page = "styles-module--home_page--494UO";